<p-toast position="bottom-center" />

<p-dialog
  [visible]="zustimmungPending()"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  header="Willkommen bei Quimus Labs – schön, dass du da bist!"
  styleClass="zustimmung-dialog"
>
  <p>
    Das Preisradar ist ein experimentelles Feature aus Quimus Labs, um geänderte Preise von Bestandsartikeln zu identifizieren und
    Preisetiketten zu drucken. Quimus Labs Prototypen nutzen wir, um neue Funktionen
    frühzeitig gemeinsam mit Pilotkunden zu testen und weiterzuentwickeln.
  </p>
  <p class="zustimmung-notice-heading">Bitte beachte:</p>
  <ul class="zustimmung-list">
    <li>Es besteht kein Anspruch auf dauerhafte Verfügbarkeit des Features oder Support.</li>
    <li>Funktionen können sich jederzeit ändern oder entfallen.</li>
    <li>Fehler in Prototypen werden nicht zwingend zeitnah behoben.</li>
    <li>Wir würden uns sehr über dein Feedback zu der Funktion freuen (Menüpunkt Feedback) und
        verarbeiten die eingegebenen Daten, um das Feature fortlaufend zu verbessern.</li>
  </ul>
  <div class="zustimmung-checkbox-row">
    <p-checkbox
      [(ngModel)]="zustimmungAkzeptiert"
      [binary]="true"
      inputId="zustimmungCheckbox"
    />
    <label for="zustimmungCheckbox">Ich habe den Hinweis gelesen und bin einverstanden.</label>
  </div>
  <ng-template #footer>
    <p-button
      label="Preisradar starten"
      icon="pi pi-play"
      [disabled]="!zustimmungAkzeptiert"
      [loading]="zustimmungSaving()"
      (onClick)="onZustimmen()"
    />
  </ng-template>
</p-dialog>

<!-- Einstellungs-Dialog -->
<p-dialog
  [visible]="einstellungenDialogVisible()"
  (visibleChange)="einstellungenDialogVisible.set($event)"
  header="Einstellungen"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '30rem' }"
>
  <div class="einstellungen-section">
    <p class="einstellungen-label">Vorbelegung „Preisänderungen ab" in „Preisänderungen":</p>

    <div class="einstellungen-radio-row">
      <p-radiobutton
        name="datumModus"
        value="tage"
        [(ngModel)]="einstellungenModus"
        inputId="modus_tage"
      />
      <label for="modus_tage" class="einstellungen-radio-label">
        <p-inputnumber
          [(ngModel)]="einstellungenTage"
          [min]="1"
          [max]="365"
          [showButtons]="true"
          buttonLayout="horizontal"
          decrementButtonIcon="pi pi-minus"
          incrementButtonIcon="pi pi-plus"
          [inputStyle]="{ width: '3.5rem', textAlign: 'center' }"
          [disabled]="einstellungenModus !== 'tage'"
          (click)="einstellungenModus = 'tage'"
        />
        Tage zurück
      </label>
    </div>

    <div class="einstellungen-radio-row">
      <p-radiobutton
        name="datumModus"
        value="letzte_suche"
        [(ngModel)]="einstellungenModus"
        inputId="modus_letzte"
      />
      <label for="modus_letzte" class="einstellungen-radio-label">
        Datum der letzten Preissuche
      </label>
    </div>
  </div>

  <div class="einstellungen-section">
    <p class="einstellungen-label">Etikettendruck:</p>
    <div class="einstellungen-radio-row">
      <p-checkbox
        [(ngModel)]="einstellungenBezeichnung"
        [binary]="true"
        inputId="bezeichnung_etikett"
      />
      <label for="bezeichnung_etikett" class="einstellungen-radio-label">
        Bezeichnung auf Etikett drucken
      </label>
    </div>
    <div class="einstellungen-radio-row">
      <p-checkbox
        [(ngModel)]="einstellungenWarengruppe"
        [binary]="true"
        inputId="warengruppe_etikett"
      />
      <label for="warengruppe_etikett" class="einstellungen-radio-label">
        Warengruppe auf Etikett drucken
      </label>
    </div>
  </div>

  <ng-template #footer>
    <p-button
      label="Speichern"
      icon="pi pi-check"
      (onClick)="saveEinstellungen()"
      [loading]="einstellungenSaving()"
    />
    <p-button
      label="Abbrechen"
      icon="pi pi-times"
      severity="secondary"
      [outlined]="true"
      (onClick)="einstellungenDialogVisible.set(false)"
    />
  </ng-template>
</p-dialog>

<div class="app-shell">
  <header class="app-header">
    <div class="header-content">
      <div class="header-left">
        <button class="burger-btn" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen" aria-label="Menü">
          <i class="pi" [class.pi-bars]="!menuOpen" [class.pi-times]="menuOpen"></i>
        </button>
        <a routerLink="/" class="logo-link">
          <img src="assets/logo/preisradar-logo.svg" alt="Preisradar" class="app-logo" />
        </a>
        <nav class="main-nav">
          <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
            <i class="pi pi-home"></i>
            Start
          </a>
          <a routerLink="/preisaktualisierungen" routerLinkActive="active" class="nav-link">
            <i class="pi pi-tags"></i>
            Preisänderungen
          </a>
          <a routerLink="/etikettendruck" routerLinkActive="active" class="nav-link">
            <i class="pi pi-print"></i>
            Etikettendruck
          </a>
          <a routerLink="/feedback" routerLinkActive="active" class="nav-link">
            <i class="pi pi-comment"></i>
            Feedback
          </a>
        </nav>
      </div>
      <div class="header-right">
        @if (haendlerBezeichnung) {
          <span class="user-info">
            <i class="pi pi-building" [title]="'Händler-ID: ' + haendlerId"></i>
            {{ haendlerBezeichnungShort }}
          </span>
        }
        @if (userName) {
          <span class="user-info user-name">
            <i class="pi pi-user"></i>
            {{ userName }}
          </span>
        }
        <button class="settings-btn" (click)="openEinstellungen()" title="Einstellungen">
          <i class="pi pi-cog"></i>
        </button>
        <button class="logout-btn" (click)="logout()" title="Abmelden">
          <i class="pi pi-sign-out"></i>
          <span>Abmelden</span>
        </button>
      </div>
    </div>
  </header>

  @if (menuOpen) {
    <div class="mobile-menu" (click)="closeMenu()">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="mobile-nav-link" (click)="closeMenu()">
        <i class="pi pi-home"></i>
        Start
      </a>
      <a routerLink="/preisaktualisierungen" routerLinkActive="active" class="mobile-nav-link" (click)="closeMenu()">
        <i class="pi pi-tags"></i>
        Preisaktualisierungen
      </a>
      <a routerLink="/etikettendruck" routerLinkActive="active" class="mobile-nav-link" (click)="closeMenu()">
        <i class="pi pi-print"></i>
        Etikettendruck
      </a>
      <a routerLink="/feedback" routerLinkActive="active" class="mobile-nav-link" (click)="closeMenu()">
        <i class="pi pi-comment"></i>
        Feedback
      </a>
      <div class="mobile-menu-divider"></div>
      <div class="mobile-user-info">
        @if (haendlerBezeichnung) {
          <span><i class="pi pi-building"></i> {{ haendlerBezeichnung }}</span>
        }
        @if (userName) {
          <span><i class="pi pi-user"></i> {{ userName }}</span>
        }
      </div>
      <button class="mobile-logout-btn" (click)="logout()">
        <i class="pi pi-sign-out"></i>
        Abmelden
      </button>
    </div>
  }

  <main class="app-main">
    <router-outlet />
  </main>

  <footer class="app-footer">
    <span>Quimus Labs &middot; Preisradar &middot; Experimentelle Funktion</span>
    <a routerLink="/datenschutz" class="footer-link">Datenschutzerklärung</a>
  </footer>
</div>
